import { render, staticRenderFns } from "./MessageQueue.vue?vue&type=template&id=6366543c&scoped=true"
import script from "./MessageQueue.vue?vue&type=script&lang=js"
export * from "./MessageQueue.vue?vue&type=script&lang=js"
import style0 from "./MessageQueue.vue?vue&type=style&index=0&id=6366543c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6366543c",
  null
  
)

/* custom blocks */
import block0 from "@/lang/common.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fbuilds%2Fref133%2Fpcnweb%2Ffrontend%2Fsrc%2Fcomponents%2FMessageQueue.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports